// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__uwSI-","show-more":"show-more__21Thx","showMore":"show-more__21Thx","active":"active__1xSFs","product":"product__3ZdBX"};